/**
 * Valid transaction relations for runtime validation
 */
export const VALID_TRANSACTION_RELATIONS = [
    'sender',
    'recipient',
    'business'
];
/**
 * Type guard to validate relation strings at runtime
 */
export function isValidTransactionRelation(value) {
    return VALID_TRANSACTION_RELATIONS.includes(value);
}
//# sourceMappingURL=transaction-include-relation.type.js.map